import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  EMAIL_ERROR_ID,
  FORM_FIELD_CLASS_NAMES,
  FORM_FIELD_NAMES,
} from 'site-modules/dealerships/constants/dealer-review';
import { FormField } from 'site-modules/shared/components/form-field/form-field';
import { FieldError } from 'site-modules/shared/components/field-error/field-error';

export function DealerReviewEmailField({ fieldRef, validate, validationErrors, isUpdate = false }) {
  const isEmailError = FORM_FIELD_NAMES.EMAIL in validationErrors;

  return (
    <Fragment>
      {isUpdate && <p className="size-16">Please verify the email used to create the original review.</p>}
      <FormField
        {...FORM_FIELD_CLASS_NAMES}
        ref={fieldRef}
        name={FORM_FIELD_NAMES.EMAIL}
        id={FORM_FIELD_NAMES.EMAIL}
        ariaDescribedBy={EMAIL_ERROR_ID}
        label={
          <Fragment>
            Email*{' '}
            {!isUpdate && (
              <span className="fw-normal">
                (will <i>not</i> be published with review)
              </span>
            )}
          </Fragment>
        }
        placeholder="Enter email address"
        type="email"
        autoComplete="email"
        required={!isUpdate}
        onBlur={validate}
        onChange={validate}
        isValid={!isEmailError}
        ariaInvalid={isEmailError}
        inputClassName="py-0_5"
      />
      <FieldError id={EMAIL_ERROR_ID} classes="mb-0_25 size-14" error={validationErrors[FORM_FIELD_NAMES.EMAIL]} />
    </Fragment>
  );
}

DealerReviewEmailField.propTypes = {
  validate: PropTypes.func.isRequired,
  fieldRef: PropTypes.func.isRequired,
  isUpdate: PropTypes.bool,
};
